import React, { ReactNode, memo, useEffect, useState } from "react";
import { isNil, isEmpty } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Container, Grid, Paper } from "@mui/material";
import Layout from "../../Layout";
import { fetchRequest as fetchPermission } from "../../../store/permission/actions";
import {
  fetchRequest as fetchUserGroup,
  saveRequest,
} from "../../../store/usergroup/actions";
import { getById } from "../../../store/usergroup/queries";
import Alert from "@mui/lab/Alert";
import { UserGroup, Data } from "../../../store/usergroup/types";
import pageStyles from "../../pageStyles";
import { withFormik } from "formik";
import useSession from "../../../effects/useSession";
import PageHeading from "../../../common/pageHeading/PageHeading";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import UserGroupEditForm from "./UserGroupEditForm";
import { schema } from "./userGroupEditForm.schema";
import { toast } from "react-toastify";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

function UserGroupEdit(): React.ReactElement {
  const { id } = useParams<{ id: string }>();

  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const session = useSession();

  const mode = id ? UPDATE : CREATE;

  const userGroup = useSelector(id ? getById(id) : () => null) as Data;
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    dispatch(fetchPermission());
    !isNil(id) && dispatch(fetchUserGroup(id));
  }, []);

  const InnerForm = () => {
    return <UserGroupEditForm id={id} />;
  };

  const EditForm = withFormik<Data, Data>({
    mapPropsToValues: (data) => {
      let initialValues = !isEmpty(data)
        ? Object.assign({}, data)
        : {
            id: null,
            type: "UserGroup",
            attributes: {
              Name: "",
              Access: [],
              Permission: {},
            },
          };
      return initialValues;
    },
    handleSubmit: (values) => {
      const callback = (err: string | null, data: UserGroup | null) => {
        if (err) {
          console.log(err);
          let errText = `An error occurred while saving: ${err}`;
          toast.error(errText, {
            closeOnClick: true,
          });
        } else {
          if (mode === CREATE) {
            history.goBack();
          } else {
            toast.success("Saved successfully!", {
              closeOnClick: true,
            });
          }
        }
      };
      dispatch(saveRequest(values, callback));
    },
    validationSchema: schema,
  })(InnerForm);

  const headingText = () => {
    return mode === CREATE ? "New Role" : "Edit Role";
  };

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <SectionWrapper title="Role">
                  <EditForm {...userGroup} />
                </SectionWrapper>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
export default UserGroupEdit;
